module.exports = __webpack_public_path__ + "img/vertical_3_2_6000.5f3b404a.png";